"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./IconListItemBlock.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _checkForDangerouslySet = require("../../utils/methods/checkForDangerouslySet");
var _BoundedCardLinkIcon = require("../BoundedCard/BoundedCardLinkIcon");
var _CTASectionMethods = require("../CTASection/CTASectionMethods");
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/methods/formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const IconListItemBlock = _ref => {
  let {
    content = {},
    VideoComponent,
    contentfulId
  } = _ref;
  const [override, setOverride] = (0, _react.useState)(false);
  const {
    text,
    header,
    type,
    color,
    link,
    Link
  } = content;
  const renderHeader = () => {
    return /*#__PURE__*/_react.default.createElement("h4", {
      className: "ter-icon-list-item-block__header",
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header),
      "data-sb-field-path": "header"
    });
  };
  const componentInner = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-icon-list-item-block__icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    sbProps: contentfulId ? {
      "data-sb-field-path": "listItemIcon"
    } : null,
    type: type || "ter-icon--enclosed-arrow-right-dark-48px",
    size: "48px",
    color: color || "#242D2F",
    className: "ter-icon-list-item-block__icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-icon-list-item-block__content-wrapper"
  }, header && renderHeader(), text && (0, _checkForDangerouslySet.checkAndSet)(text, "ter-icon-list-item-block", null, color)));
  const renderLink = link => {
    if (link && link?.text) {
      let external = (0, _CTASectionMethods.checkForExternalLink)(link?.url) === true ? "_blank" : "_self";
      return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        contentfulId: link?.contentfulId ? link?.contentfulId : null,
        to: link?.url,
        target: external,
        className: "ter-icon-list-item-block__link-text",
        video: link?.video ? link?.video : null,
        VideoComponent: VideoComponent ? VideoComponent : null,
        setOverride: link?.video ? setOverride : null,
        override: link?.video ? override : null,
        Link: Link && Link,
        onClick: link?.onClick,
        con: true
      }, /*#__PURE__*/_react.default.createElement("span", null, link?.text), /*#__PURE__*/_react.default.createElement(_BoundedCardLinkIcon.CardLinkIcon, {
        iconClass: (0, _CTASectionMethods.checkForExternalLink)(link?.url) ? "ter-icon-list-item-block__link-icon ter-icon-list-item-block__link-icon-external" : "ter-icon-list-item-block__link-icon",
        external: (0, _CTASectionMethods.checkForExternalLink)(link?.url)
      }));
    }
  };
  const renderComponent = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-icon-list-item-block`,
      "data-sb-object-id": contentfulId ? contentfulId : null
    }, componentInner, link && renderLink(link));
  };
  return renderComponent();
};
var _default = IconListItemBlock;
exports.default = _default;
IconListItemBlock.propTypes = {
  content: _propTypes.default.shape({
    header: _propTypes.default.string,
    text: _propTypes.default.string,
    type: _propTypes.default.string,
    color: _propTypes.default.string,
    link: _propTypes.default.object
  })
};